module.exports = __webpack_public_path__ + "img/DW365-177.6655c186.jpg";